<template>
  <div>
    <div class="row mb-10" style="height: 200px">
      <div class="col row background-color-white mt-8 ml-4 mr-4">
        <div class="col card-head-tab">
          <div style="position: absolute; top: 20px; left: 15px" class="h5 font-weight-bolder">今日调用</div>
          <div>
            <div class="font-weight-boldest card-head-tab text-muted">总调用量</div>
            <div class="h3 font-weight-boldest card-head-tab pt-4">{{ todaydData.totalCount }}点</div>
          </div>
        </div>
        <div class="bord"></div>
        <div class="col row card-head-tab">
          <div class="col">
            <div class="card-head-tab font-weight-boldest text-muted">成功量</div>
            <div class="card-head-tab h3 font-weight-boldest pt-4 text-success">{{ todaydData.successCount }}点</div>
          </div>
        </div>
        <div class="col row card-head-tab">
          <div class="col">
            <div class="card-head-tab font-weight-boldest text-muted">失败量</div>
            <div class="card-head-tab h3 font-weight-boldest pt-4 text-danger">{{ todaydData.failCount }}点</div>
          </div>
        </div>
      </div>
      <div class="col-3 background-color-white mt-8 ml-4 mr-4">
        <div id="containerPie"></div>
      </div>
    </div>
    <div class="background-color-white p-8" v-loading="dayLoading">
      <div class="h5 font-weight-boldest">日调用量统计</div>
      <div class="text-muted pt-2 pb-4">可查询1个月范围内资源调用量</div>
      <div class="d-flex pb-8">
        <div class="d-flex align-items-center">
          <span>时间范围：</span>
          <div class="">
            <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 400px"> </el-date-picker>
            <!-- <div class="col-12 text-muted" style="font-size: 12px">可查询1个月范围内资源调用量</div> -->
          </div>
        </div>
        <div class="d-flex align-items-center ml-3">
          <div>
            <button type="reset" class="btn btn-primary" @click="eFilter('time')">统计</button>
          </div>
        </div>
        <div class="d-flex align-items-center ml-3">
          <div style="width: 150px">
            <button type="reset" class="btn btn-primary" @click="eFilterTime">近30天</button>
          </div>
        </div>
      </div>
      <div id="containerLine"></div>
    </div>
    <div class="background-color-white p-8 mt-8" v-loading="monthLoading">
      <div class="h5 font-weight-boldest">月调用量统计</div>
      <div class="text-muted pt-2 pb-4">可查询1年范围内资源调用量</div>
      <div class="d-flex pb-8">
        <div class="d-flex align-items-center">
          <span>时间范围：</span>
          <div class="">
            <el-date-picker v-model="monthrange" type="monthrange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 400px"> </el-date-picker>
          </div>
        </div>
        <div class="d-flex align-items-center ml-3">
          <div>
            <button type="reset" class="btn btn-primary" @click="eFilter('year')">统计</button>
          </div>
        </div>
        <div class="d-flex align-items-center ml-3">
          <div style="width: 150px">
            <button type="reset" class="btn btn-primary" @click="eFilterYear">近1年</button>
          </div>
        </div>
      </div>
      <div id="containerColumn"></div>
    </div>
    <vi-loading-new v-model="loading"></vi-loading-new>
  </div>
</template>

<script>
import { Line, Pie, Column } from "@antv/g2plot";
var moment = require("moment");
export default {
  name: "Centre",
  components: {},
  props: {
    userSN: String,
  },
  data() {
    return {
      monthLoading: false,
      dayLoading: false,
      loading: false,
      pickerOption: null,
      time: "",
      monthrange: "",
      piePlot: null,
      linePlot: null,
      todaydData: {},
      columnPlot: null,
    };
  },
  mounted() {
    this.eGetTime();
    this.oReload();
  },
  methods: {
    eGetTime() {
      // let fristDate = new Date().setDate(1);
      // let currentDate = new Date().getTime();
      let fristDate = moment().subtract(29, "days").startOf("day");
      let currentDate = moment().endOf("day");
      this.time = [fristDate, currentDate];

      let yearsDate = moment().add(1, "M").subtract(1, "years").startOf("month").format("YYYY/MM/DD");
      let date = moment().endOf("month").format("YYYY/MM/DD");
      this.monthrange = [yearsDate, date];
    },
    eFilter(type) {
      if (type == "time") {
        if (!this.time) {
          this.$$.toastr.error("请选择时间范围");
          return;
        }
        let beginData = moment(this.time[0]).startOf("day").format("YYYY-MM-DD");
        let time = moment(this.time[1]).endOf("day").format("YYYY-MM-DD");
        let endData = moment(time);
        let day = endData.diff(beginData, "day");
        if (day > 31) {
          this.$$.toastr.error("查询时间范围不能超过一个月");
          return;
        }
        let args = {
          userSN: this.userSN,
          productType: "OcrNormal",
          cycleType: "Day",
          beginTime: moment(this.time[0]).startOf("day").format("x"),
          endTime: moment(this.time[1]).startOf("day").format("x"),
        };
        this.dayLoading = true;
        this.oGetSummaryList(args);
      }

      if (type == "year") {
        if (!this.monthrange) {
          this.$$.toastr.error("请选择时间范围");
          return;
        }
        let beginData = moment(this.monthrange[0]).startOf("day").format("YYYY-MM-DD");
        let time = moment(this.monthrange[1]).endOf("month").format("YYYY-MM-DD");
        let endData = moment(time);
        let day = endData.diff(beginData, "day");
        if (day > 366) {
          this.$$.toastr.error("查询时间范围不能超过一年");
          return;
        }
        let args = {
          userSN: this.userSN,
          cycleType: "Day",
          productType: "OcrNormal",
          beginTime: moment(this.monthrange[0]).startOf("day").format("YYYY/MM/DD"),
          endTime: moment(this.monthrange[1]).endOf("month").format("YYYY/MM/DD"),
        };
        this.monthLoading = true;
        this.oGetUsageSummaryList(args);
      }
    },
    eFilterTime() {
      let date = [moment().subtract(29, "days"), moment()];
      let args = {
        userSN: this.userSN,
        productType: "OcrNormal",
        cycleType: "Day",
        beginTime: moment(date[0]).startOf("day").format("x"),
        endTime: moment(date[1]).startOf("day").format("x"),
      };

      this.time = [moment(date[0]).startOf("day").format("YYYY/MM/DD"), moment(date[1]).startOf("day").format("YYYY/MM/DD")];
      this.oGetSummaryList(args);
      this.dayLoading = true;
    },
    eFilterYear() {
      let date = [moment().subtract(1, "years"), moment()];
      let args = {
        userSN: this.userSN,
        productType: "OcrNormal",
        cycleType: "Day",
        beginTime: moment(date[0]).add(1, "M").startOf("month").format("YYYY/MM/DD"),
        endTime: moment(date[1]).endOf("month").format("YYYY/MM/DD"),
      };
      this.monthrange = [args.beginTime, args.endTime];
      this.monthLoading = true;
      this.oGetUsageSummaryList(args);
    },
    oReload() {
      this.loading = true;
      let listArgs = {
        userSN: this.userSN,
        productType: "OcrNormal",
        cycleType: "Day",
        beginTime: moment().add(1, "M").subtract(1, "years").startOf("month").format("YYYY/MM/DD"),
        endTime: moment().endOf("month").format("YYYY/MM/DD"),
      };
      this.oGetUsageSummaryList(listArgs);

      let args = {
        userSN: this.userSN,
        productType: "OcrNormal",
        cycleType: "Day",
      };
      this.oGetSummaryOverview(args);

      args.beginTime = moment(this.time[0]).startOf("day").format("x");
      args.endTime = moment(this.time[1]).startOf("day").format("x");

      this.oGetSummaryList(args);
    },
    oGetSummaryOverview(item) {
      this.$$.api
        .post("/shiyun/marketing/apis/biz/console/product/usage/summary/overview", item)
        .then((res) => {
          this.todaydData = res.data.today;
          this.eGetPie();
        })
        .catch((e) => {
          this.$$.toastr.error(`错误信息：${e.message}`);
        });
    },
    oGetSummaryList(item) {
      this.$$.api
        .post("/shiyun/marketing/apis/biz/console/product/usage/summary/list", item)
        .then((res) => {
          let list = res.data.list;
          list.sort(function (a, b) {
            return a.cycleTime < b.cycleTime ? -1 : 1;
          });
          this.eGetLine(list);
          this.loading = false;
          this.dayLoading = false;
        })
        .catch((e) => {
          this.$$.toastr.error(`错误信息：${e.message}`);
          this.loading = false;
          this.dayLoading = false;
        });
    },
    oGetUsageSummaryList(item) {
      this.$$.api
        .post("/shiyun/marketing/apis/biz/console/product/usage/summary/list", item)
        .then((res) => {
          let list = res.data.list;
          list.sort(function (a, b) {
            return a.cycleTime < b.cycleTime ? -1 : 1;
          });
          this.eGetColumn(list);
          this.loading = false;
          this.monthLoading = false;
        })
        .catch((e) => {
          this.$$.toastr.error(`错误信息：${e.message}`);
          this.loading = false;
          this.monthLoading = false;
        });
    },
    eGetPie() {
      let data = [
        { type: "成功量", value: this.todaydData.successCount },
        { type: "失败量", value: this.todaydData.failCount },
      ];
      if (this.piePlot) {
        this.piePlot.changeData(data);
      } else {
        if (!document.getElementById("containerPie")) {
          return;
        }
        this.piePlot = new Pie("containerPie", {
          appendPadding: 10,
          data,
          width: 180,
          height: 180,
          angleField: "value",
          colorField: "type",
          radius: 1,
          innerRadius: 0.6,
          label: {
            type: "inner",
            offset: "-50%",
            content: "{value}",
            style: {
              textAlign: "center",
              fontSize: 14,
            },
            autoRotate: false,
          },
          color: ["#62daab", "#f1416c"],
          legend: {
            position: "right",
            itemName: {
              formatter: (text) => {
                return text;
              },
            },
          },
          tooltip: {
            customContent: (value, items) => {
              return `<div>
                            <div>${items?.[0]?.data.type}</div>
                            <li class="g2-tooltip-list-item">
                                <span class="g2-tooltip-marker" style="background-color:#7BD4E0;width:0px;height:0px;border-radius:50%;display:inline-block;margin-right:8px;"></span>
                           <span class="g2-tooltip-value">${items?.[0]?.data.value}点</span>
                            </li>
                         </div>`;
            },
            domStyles: {
              "g2-tooltip": {
                paddingTop: "12px",
              },
            },
          },
          interactions: [{ type: "element-selected" }, { type: "element-active" }],
          statistic: {
            title: false,
            content: {
              style: {
                whiteSpace: "pre-wrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
              content: "",
            },
          },
        });
        this.piePlot.render();
      }
    },
    eGetLine(item) {
      let data = [];
      item.map((p) => {
        let cycleTime = moment(p.cycleTime).format("MM-DD");
        let totalArgs = {
          year: cycleTime,
          value: p.totalCount,
          category: "调用资源量总量",
        };
        data.push(totalArgs);

        let successArgs = {
          year: cycleTime,
          value: p.successCount,
          category: "调用成功资源量",
        };
        data.push(successArgs);

        let failArgs = {
          year: cycleTime,
          value: p.failCount,
          category: "调用失败资源量",
        };
        data.push(failArgs);
      });
      if (this.linePlot) {
        this.linePlot.changeData(data);
      } else {
        if (!document.getElementById("containerLine")) {
          return;
        }
        this.linePlot = new Line("containerLine", {
          data,
          xField: "year",
          yField: "value",
          seriesField: "category",
          legend: {
            position: "bottom",
          },
          yAxis: {
            label: {
              formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
            },
          },
          point: {
            style: ({ year }) => {
              return {
                r: Number(year) % 4 ? 0 : 3,
              };
            },
          },
        });
        this.linePlot.render();
      }
    },
    eGetColumn(item) {
      let data = [];
      item.map((p) => {
        let cycleTime = moment(p.cycleTime).format("YYYY-MM");
        let findSuccessCount = data.find((f) => f.cycleTime == cycleTime && f.type == "调用成功资源量");
        if (findSuccessCount) {
          findSuccessCount.value = p.successCount + findSuccessCount.value;
        } else {
          let successArgs = {
            cycleTime: cycleTime,
            year: cycleTime,
            value: p.successCount,
            type: "调用成功资源量",
          };
          data.push(successArgs);
        }
        let findFailCount = data.find((f) => f.cycleTime == cycleTime && f.type == "调用失败资源量");
        if (findSuccessCount) {
          findFailCount.value = p.failCount + findFailCount.value;
        } else {
          let failArgs = {
            cycleTime: cycleTime,
            year: cycleTime,
            value: p.failCount,
            type: "调用失败资源量",
          };
          data.push(failArgs);
        }
      });

      if (this.columnPlot) {
        this.columnPlot.changeData(data);
      } else {
        if (!document.getElementById("containerColumn")) {
          return;
        }
        this.columnPlot = new Column("containerColumn", {
          data,
          isStack: true,
          xField: "year",
          yField: "value",
          seriesField: "type",
          yAxis: {
            label: {
              formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
            },
          },
          legend: {
            position: "top",
          },
          label: {
            position: "middle",
            layout: [{ type: "interval-adjust-position" }, { type: "interval-hide-overlap" }, { type: "adjust-color" }],
          },
        });

        this.columnPlot.render();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.background-color-white {
  background-color: #ffffff;
  border-radius: 5px 5px 5px 5px;
}

.card-head-tab {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bord {
  margin-top: 8px;
  margin-bottom: 8px;
  border-left: 1px solid rgb(175, 173, 173);
}
</style>
